<template>
  <v-row no-gutters justify="center">
    <v-col cols="auto" class="text-center">
      <annotation-mode-button
        :image="coloredAssetUrls.line"
        :activeImage="activeAnnotationIcons.line"
        title="Line"
        @click="$emit('input', annotationModes.LengthLine)"
        :buttonMode="annotationModes.LengthLine"
        :annotationMode="context.annotationMode"
        :size="size"/>
      <annotation-mode-button
        :image="coloredAssetUrls.area"
        :activeImage="activeAnnotationIcons.area"
        title="Area"
        @click="$emit('input', annotationModes.Area)"
        :buttonMode="annotationModes.Area"
        :annotationMode="context.annotationMode"
        :size="size"/>
      <annotation-mode-button
        :image="coloredAssetUrls.cupToDisc"
        :activeImage="activeAnnotationIcons.cupToDisc"
        title="Cup To Disc"
        @click="$emit('input', annotationModes.CupToDisc)"
        :buttonMode="annotationModes.CupToDisc"
        :annotationMode="context.annotationMode"
        :size="size"/>
      <annotation-mode-button
        :image="coloredAssetUrls.freehandArea"
        :activeImage="activeAnnotationIcons.freehandArea"
        title="Free Hand Area"
        @click="$emit('input', annotationModes.FreeHandArea)"
        :buttonMode="annotationModes.FreeHandArea"
        :annotationMode="context.annotationMode"
        :size="size"/>
      <annotation-mode-button
        :image="coloredAssetUrls.pdt"
        :activeImage="activeAnnotationIcons.pdt"
        title="PDT"
        @click="$emit('input', annotationModes.PDT)"
        :buttonMode="annotationModes.PDT"
        :annotationMode="context.annotationMode"
        :size="size"/>
      <annotation-mode-button
        :image="coloredAssetUrls.etdrs"
        :activeImage="activeAnnotationIcons.etdrs"
        title="ETDRS Grid"
        @click="$emit('input', annotationModes.ETDRSGrid)"
        :buttonMode="annotationModes.ETDRSGrid"
        :annotationMode="context.annotationMode"
        :size="size"/>
      <annotation-mode-button
        :image="coloredAssetUrls.smallStandardCircles"
        :activeImage="activeAnnotationIcons.smallStandardCircles"
        title="Standard Circles C0, C1, C2"
        @click="$emit('input', annotationModes.StandardCircles1)"
        :buttonMode="annotationModes.StandardCircles1"
        :annotationMode="context.annotationMode"
        :size="size"/>
      <annotation-mode-button
        :image="coloredAssetUrls.standardCircles"
        :activeImage="activeAnnotationIcons.standardCircles"
        title="Standard Circles C3, C4"
        @click="$emit('input', annotationModes.StandardCircles2)"
        :buttonMode="annotationModes.StandardCircles2"
        :annotationMode="context.annotationMode"
        :size="size"/>
      <annotation-mode-button
        :image="coloredAssetUrls.smallDrusenCircles"
        :activeImage="activeAnnotationIcons.smallDrusenCircles"
        title="Drusen Circles C-0, C-1, C-2"
        @click="$emit('input', annotationModes.DrusenCircles1)"
        :buttonMode="annotationModes.DrusenCircles1"
        :annotationMode="context.annotationMode"
        :size="size"/>
      <annotation-mode-button
        :image="coloredAssetUrls.drusenCircles"
        :activeImage="activeAnnotationIcons.drusenCircles"
        title="Drusen Circles I-2, O-2"
        @click="$emit('input', annotationModes.DrusenCircles2)"
        :buttonMode="annotationModes.DrusenCircles2"
        :annotationMode="context.annotationMode"
        :size="size"/>
      <annotation-mode-button
        :image="coloredAssetUrls.drusenHalf"
        :activeImage="activeAnnotationIcons.drusenHalf"
        title="Drusen Circles ½ DA"
        @click="$emit('input', annotationModes.DrusenCircles3)"
        :buttonMode="annotationModes.DrusenCircles3"
        :annotationMode="context.annotationMode"
        :size="size"/>
      <annotation-mode-button
        :image="coloredAssetUrls.drusenCircle"
        :activeImage="activeAnnotationIcons.drusenCircle"
        title="Drusen Circles 1 DA"
        @click="$emit('input', annotationModes.DrusenCircles4)"
        :buttonMode="annotationModes.DrusenCircles4"
        :annotationMode="context.annotationMode"
        :size="size"/>
      <annotation-mode-button
        :image="coloredAssetUrls.rectangle"
        :activeImage="activeAnnotationIcons.rectangle"
        title="Rectangle"
        @click="$emit('input', annotationModes.Rectangle)"
        :buttonMode="annotationModes.Rectangle"
        :annotationMode="context.annotationMode"
        :size="size"/>
    </v-col>
  </v-row>
</template>

<script>
import { ANNOTATION_MODES } from "../../../config/config";
import annotationModeButton from "../../imageBrowser/controls/AnnotationModeButton";

export default {
  name: "annotationMeasurementButtonCollection",
  components: { annotationModeButton },
  props: {
    context: Object,
    size: { type: String, default: "small" }
  },
  data() {
    return {
      annotationModes: ANNOTATION_MODES
    };
  },
  methods: {
    buttonClass(color) {
      let btnClass = "rounded-button annotation-color-button "  + this.colorClass;
      if (color === this.value) btnClass += " selected-color";
      return btnClass;
    }
  }
};
</script>
